import { connect } from 'react-redux'
import {changeLabel,selectActivities,fetchActivity} from '../actions'
import MyActivitiesList from '../components/MyActivitiesList'

const mapStateToProps = (state) => {
    return state;
}

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeLabel: (key,value) => {
            dispatch(changeLabel(key,value));
        },
        onSelectActivities: (activities,indices) => {
            dispatch(selectActivities(activities,indices));
        },
        onFetchActivity:(id,token,options)=>{
            dispatch(fetchActivity(id,token,options))
        },
    }
}

const RxMyActivitiesList = connect(
    mapStateToProps,
    mapDispatchToProps
)(MyActivitiesList)

export default RxMyActivitiesList


// WEBPACK FOOTER //
// ./src/containers/RxMyActivitiesList.js